<template>
  <div class="map">
    <iframe
      :src="url_map"
      style="width: 100%; height: 100%; border:0;"
      frameborder="0"
      allowfullscreen=""
      aria-hidden="false"
      tabindex="0">
    </iframe>
  </div>
</template>

<script>
  export default {
    props: {
      url_map: String
    }
  }
</script>

